import React, { useContext } from 'react';
import SmsPutSetting from '@/components/SMS/SmsPutSetting';
import {ActivityContext} from '../../index';
import SmsTest from '@/components/SMS/SmsTest';
function PutSetting(props) {
  const { task, taskParams, setTaskParams, type, pageDisable, refresh } = useContext(ActivityContext);
  return (
    <div style={{padding:'10px 0px'}}>
      <SmsPutSetting
        channelType='CN_NTC' 
        typeCode={task}
        pageDisable={pageDisable}
        pageType={type==='edit' ? 3 : type==='view' ?  2 : ''}
        smsParams={{...taskParams.sendContent}} 
        setSmsParams={(v)=>{
          let newSendContent = {...taskParams.sendContent}
          setTaskParams({ 
            ...taskParams,
            sendContent:{
              ...newSendContent,
              ...v
            }
          })
        }}
        refresh={refresh}
      />
      <SmsTest smsContent={taskParams.sendContent.smsContent} templateId={taskParams.sendContent.templateId}/>
    </div>
  );
}

export default PutSetting;
